<template>
  <div v-if="enableVideoCall">
    <div
      @click.stop="startAudioVoice()"
      :disabled="isLoading"
      class="button-video-call horizontal layout center"
    >
      <i class="fas fa-video" v-if="!isLoading"></i>
      <aha-spinner
        size="xs"
        variant="white"
        v-if="isLoading"
        class="inline-block"
      />
      <span>Call</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import opentokApi from '@/api/opentok'
import utils from '@/util'
import config from '@/config'
import constants from '@/constant'

export default {
  components: {
  },
  props: {
    audienceUnique: {
      type: String,
      required: true,
    },
    audienceName: {
      type: String,
      default: 'Anonymous',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      sharePresentation: (state) => state.sharePresentation,
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isBackstage']),
    enableVideoCall() {
      if (this.isBackstage || config.region === constants.euRegion
        || this.sharePresentation) return false
      return true
    },
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    async startAudioVoice() {
      if (this.isLoading) return
      this.isLoading = true
      const resp = await opentokApi.checkSession({
        presentationId: this.presentation.id,
      })
      this.$store.state.presentation.expiredToken = resp.expiredToken
      this.$store.state.presentation.token = resp.token
      this.$store.state.presentation.session = resp.session
      this.$store.state.voiceCall = {
        audienceUnique: this.audienceUnique,
        audienceName: this.audienceName || 'Anonymous',
        isOpen: true,
        status: 'start-call',
      }
      this.isLoading = false
      await opentokApi.createSignal({
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        token: resp.token,
        expiredToken: resp.expiredToken,
        session: resp.session,
        audienceUnique: this.audienceUnique,
      })
      const { type, slideType } = this.slideActive
      const slideName = utils.getCorrectSlideTypeName(type, slideType)
      utils.gaTrackEvent('Video Call', 'Presenter click call audience', slideName)
    },
  },
}
</script>

<style lang="scss" scoped>
.button-video-call {
  background-color: #348EF6;
  color: #fff;
  border: 1px solid #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 14px;

  &:hover {
    background-color: #257ADC;
  }

  i {
    font-size: 12px;
  }

  span {
    margin-left: 4px;
  }
  &::v-deep {
    .aha-spinner {
      position: relative;
      top: 2px;
    }
  }
}
</style>
